import React from 'react';
import SvgIcon, {SvgIconProps} from '@material-ui/core/SvgIcon';

function AndGateIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g
        id="layer1"
        transform="translate(0,8)">
        <g
          transform="matrix(0.5034196,0,0,0.5034196,-0.76857502,8.501422)"
          id="g13024">
          <g
            id="g13009">
            <path
              d="M 4.4850507,14.695334 H 46.587745 V -9.2077529 c 0,-13.1537031 -9.473147,-23.3471961 -21.051367,-23.3471961 -11.578179,0 -21.0513273,10.193493 -21.0513273,23.3471961 z"
              id="path40-5"
              opacity="0.3" />
          </g>
          <path
            opacity="0.8"
            id="path12440"
            d="M 4.4850507,14.695334 H 46.587745 V -9.3090784 c 0,-13.2094646 -9.473154,-23.4461716 -21.051347,-23.4461716 -11.578193,0 -21.0513473,10.236706 -21.0513473,23.4461716 z M 10.416367,8.7645529 V -9.3090784 c 0,-11.4425086 7.4076,-17.5739116 15.120031,-17.5143066 7.85439,0.0607 14.984613,6.578413 15.120819,18.0725483 V 8.7645529 Z"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default AndGateIcon;

